export default __webpack_public_path__ + "static/media/plate-left.91c7758a.png";